import type { DisplayMode } from '../types';
import { StandardDisplayMode } from './standard';
import { CornerDisplayMode } from './corner';
import { BannerDisplayMode } from './banner';
import { FullscreenDisplayMode } from './fullscreen';

const modeMap: Record<string, new () => DisplayMode> = {
	popup: StandardDisplayMode,
	corner: CornerDisplayMode,
	banner: BannerDisplayMode,
	fullscreen: FullscreenDisplayMode,
};

export function createDisplayMode(type: string): DisplayMode {
	const Ctor = modeMap[type] || modeMap.popup;
	return new Ctor();
}
